(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dh-footer"] && !Shopify.designMode) return;
  try {
    

// --- IDENTIFY SECTION ID, THEN FIND FIRST BLOCK HEADER INSTANCE AND APPLY CSS CLASS --- //

(() => {
  function mark(sectionEl) {
    if (!sectionEl) return;
    // clear stale marks (editor re-renders)
    sectionEl.querySelectorAll('button.dh-footer__block-heading--button.is-first')
      .forEach(el => el.classList.remove('is-first'));

    const firstBtn = sectionEl.querySelector('button.dh-footer__block-heading--button');
    if (firstBtn) firstBtn.classList.add('is-first');
  }

  function markAll() {
    document.querySelectorAll('.dh-footer__main--container').forEach(container => {
      const sectionEl = container.closest('[id^="shopify-section-"]') || container;
      mark(sectionEl);
    });
  }

  // Storefront load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', markAll);
  } else {
    markAll();
  }

  // Theme Editor hooks
  document.addEventListener('shopify:section:load', (e) => {
    if (e.target && e.target.querySelector('.dh-footer__main--container')) mark(e.target);
  });
  document.addEventListener('shopify:section:select', (e) => {
    if (e.target && e.target.querySelector('.dh-footer__main--container')) mark(e.target);
  });
  document.addEventListener('shopify:block:select', (e) => {
    if (e.target && e.target.querySelector('.dh-footer__main--container')) mark(e.target);
  });
})();


// --- DYNAMIC COLLAPSABLE CONTENT BEHAVIOUR --- //

// Initialise one footer section
function initFooterSection(root) {
  const blocks = root.querySelectorAll('.dh-footer__block-heading--container');
  if (!blocks.length) return;

  blocks.forEach(block => {
    const button  = block.querySelector('.dh-footer__block-heading--button');
    const arrow   = block.querySelector('.dh-footer__block-heading--arrow');
    const target  = button?.dataset.targetId;
    const content = target && root.querySelector('#' + target);

    if (!button || !content || !arrow) return;

    // Guard against duplicate listeners on theme editor refreshes
    if (button.dataset.dhInit === 'true') return;
    button.dataset.dhInit = 'true';

    button.addEventListener('click', () => {
      const isCurrentlyOpen = content.classList.contains('open');

      // Close any other block that is open in this section
      root.querySelectorAll('.dh-footer__block-content--collapsable.open').forEach(el => {
        if (el !== content) {
          el.classList.remove('open');
          const parentBlock   = el.closest('.dh-footer__block-heading--container');
          const parentButton  = parentBlock?.querySelector('.dh-footer__block-heading--button');
          const parentArrow   = parentBlock?.querySelector('.dh-footer__block-heading--arrow');
          parentArrow?.classList.remove('rotate');
          parentButton?.setAttribute('aria-expanded', 'false');
        }
      });

      // Toggle the clicked block
      const isOpenNow = content.classList.toggle('open', !isCurrentlyOpen);
      arrow.classList.toggle('rotate', isOpenNow);
      button.setAttribute('aria-expanded', String(isOpenNow));
    });
  });
}

// First load
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-section-id]').forEach(initFooterSection);
});

// Theme editor AJAX reload
document.addEventListener('shopify:section:load', event => {
  const wrapper = event.target.querySelector('[data-section-id]');
  if (wrapper) initFooterSection(wrapper);
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fit-guide"] && !Shopify.designMode) return;
  try {
    

function resize_images() {
  $(function () {
    $('.cover_fit_img').matchHeight();


    $.fn.matchHeight._beforeUpdate = function (event, groups) {
      // do something before any updates are applied
      if ($(window).width() < 767) {
        $('.cover_fit_img').css('height', 'auto')
      }
      console.log("ok");
    }

    $.fn.matchHeight._afterUpdate = function (event, groups) {
      // do something after all updates are applied  
      if ($(window).width() < 767) {
        $('.cover_fit_img').css('height', 'auto')
      }
    }
  });
}

function mobile_resize() {
  if ($(window).width() < 767) {
    $('.cover_fit_img').css('height', 'auto');
  }
}

$(window).resize(function () {
  resize_images();
  mobile_resize();
});

$(window).load(function () {
  resize_images();
  mobile_resize();
});

$(".calc_size").hide();
  
function checkBraSize(e) {
  var t = parseInt($(".measurement_a").val()),
    a = parseInt($(".measurement_b").val()),
    r, o;
  if ($(".cal_error").remove(), $.trim($(".measurement_a").val()) == "" || $.trim($(".measurement_b").val()) == "") return $(this).before("<p class='cal_error'>Please enter value</p>"), e.preventDefault(), !1;
  a < 38 && (a % 2 == 0 ? o = a + 2 : o = a + 3), a >= 38 && (a % 2 == 0 ? o = a : o = a + 1);
  var s = t - a,
    n = parseInt(s),
    c = "";
  n == 1 ? c = "A" : n == 2 ? c = "B" : n == 3 ? c = "C" : n == 4 ? c = "D" : n == 5 ? c = "E" : n == 6 ? c = "F" : n == 7 ? c = "G" : n == 8 && (c = "H"), n < 9 && n > 0 ? ($(".calc_size").find(".calc_size_display").show(), $(".calc_size").find(".calc_size_display").text("Your size is: " + o + c), $(".calc_size").find(".calc_size_error").hide(), $(".calc_size").find(".calc_size_error_minus").hide()) : n > 0 ? ($(".calc_size").find(".calc_size_display").hide(), $(".calc_size").find(".calc_size_error_minus").hide(), $(".calc_size").find(".calc_size_error").show()) : ($(".calc_size").find(".calc_size_display").hide(), $(".calc_size").find(".calc_size_error").hide(), $(".calc_size").find(".calc_size_error_minus").show());

  $(".cal_button").hide();
  $(".calc_size").show();
}

$(document).ready(function () {
  resize_images();
  mobile_resize();

  $('#fit-guide .tabs .tab-1-link').on('click', function () {
    $('#fit-guide .tabs .tab-1-link').parent().addClass('fit-guide_active-tab');
    $('#fit-guide .tabs .tab-2-link').parent().removeClass('fit-guide_active-tab');
    $('#fit-guide .tabs .tab-3-link').parent().removeClass('fit-guide_active-tab');
    $('#fit-guide .tabs .tab-4-link').parent().removeClass('fit-guide_active-tab');
    $('#fit-guide #tab-1').show();
    $('#fit-guide #tab-2').hide();
    $('#fit-guide #tab-3').hide();
    $('#fit-guide #tab-4').hide();
  });

  $('#fit-guide .tabs .tab-2-link').on('click', function () {
    $('#fit-guide .tabs .tab-1-link').parent().removeClass('fit-guide_active-tab');
    $('#fit-guide .tabs .tab-2-link').parent().addClass('fit-guide_active-tab');
    $('#fit-guide .tabs .tab-3-link').parent().removeClass('fit-guide_active-tab');
    $('#fit-guide .tabs .tab-4-link').parent().removeClass('fit-guide_active-tab');
    $('#fit-guide #tab-1').hide();
    $('#fit-guide #tab-2').show();
    $('#fit-guide #tab-3').hide();
    $('#fit-guide #tab-4').hide();
  });

  $('#fit-guide .tabs .tab-3-link').on('click', function () {
    $('#fit-guide .tabs .tab-1-link').parent().removeClass('fit-guide_active-tab');
    $('#fit-guide .tabs .tab-2-link').parent().removeClass('fit-guide_active-tab');
    $('#fit-guide .tabs .tab-3-link').parent().addClass('fit-guide_active-tab');
    $('#fit-guide .tabs .tab-4-link').parent().removeClass('fit-guide_active-tab');
    $('#fit-guide #tab-1').hide();
    $('#fit-guide #tab-2').hide();
    $('#fit-guide #tab-3').show();
    $('#fit-guide #tab-4').hide();
  });

  $('#fit-guide .tabs .tab-4-link').on('click', function () {
    $('#fit-guide .tabs .tab-1-link').parent().removeClass('fit-guide_active-tab');
    $('#fit-guide .tabs .tab-2-link').parent().removeClass('fit-guide_active-tab');
    $('#fit-guide .tabs .tab-3-link').parent().removeClass('fit-guide_active-tab');
    $('#fit-guide .tabs .tab-4-link').parent().addClass('fit-guide_active-tab');
    $('#fit-guide #tab-1').hide();
    $('#fit-guide #tab-2').hide();
    $('#fit-guide #tab-3').hide();
    $('#fit-guide #tab-4').show();
  });

  $('#fit-guide #tab-3 .cal_button a.calculate-button').on('click', function () {
    checkBraSize();
  });

  $('#fit-guide #tab-3 .calc_size a.recalculate-button').on('click', function () {
    checkBraSize();
  });
});


  } catch(e) { console.error(e); }
})();
})();
